export default __webpack_public_path__ + "static/media/sp_logo_left.bd36cdaa.jpg";